/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import AMPFooter from '../components/AMPFooter';
import AMPHeader from '../components/AMPHeader';
import AdCard from '../components/Cards/AdCard';
import Article from '../components/Cards/Article';
import Collection from '../components/Cards/Collection';
import Competition from '../components/Cards/Competition';
import FanaticsProduct from '../components/Cards/FanaticsProduct';
import Googleprovider from '../components/Cards/Googleprovider';
import Image from '../components/Cards/Image';
import ImageGallery from '../components/Cards/ImageGallery';
import LiveBlogEvent from '../components/Cards/LiveBlogEvent';
import LiveStream from '../components/Cards/LiveStream';
import MatchCard from '../components/Cards/MatchCard';
import PlayerProfile from '../components/Cards/PlayerProfile';
import Podcast from '../components/Cards/Podcast';
import Poll from '../components/Cards/Poll';
import Quiz from '../components/Cards/Quiz';
import Quotes from '../components/Cards/Quotes';
import Social from '../components/Cards/Social';
import Teamlevelcalendar from '../components/Cards/Teamlevelcalendar';
import Unitedcompetition from '../components/Cards/Unitedcompetition';
import Video from '../components/Cards/Video';
import Video360Degree from '../components/Cards/Video360Degree';
import Coach from '../components/Coach';
import ComingSoon from '../components/ComingSoon';
import Comingup from '../components/Comingup';
import EventCountDownTimer from '../components/Common/EventCountDownTimer';
import ContentBlock from '../components/ContentBlock';
import AMPArticleDetail from '../components/DestinationsPages/AMPArticleDetail';
import ArticleDetail from '../components/DestinationsPages/ArticleDetail';
import CollectionDetail from '../components/DestinationsPages/CollectionDetail';
import CompetitionDetail from '../components/DestinationsPages/CompetitionDetail';
import CompetitionDetailForm from '../components/DestinationsPages/CompetitionDetailForm';
import ImageDetail from '../components/DestinationsPages/ImageDetail';
import ImageGalleryDetail from '../components/DestinationsPages/ImageGalleryDetail';
import LiveStreamDetail from '../components/DestinationsPages/LiveStreamDetail';
import LiveStreamViaEPGDetail from '../components/DestinationsPages/LiveStreamViaEPGDetail';
import ModelContainer from '../components/DestinationsPages/ModelContainer';
import PollDetail from '../components/DestinationsPages/PollDetail';
import QuizDetail from '../components/DestinationsPages/QuizDetail';
import QuotesDetail from '../components/DestinationsPages/QuotesDetail';
import Video360DegreeDetail from '../components/DestinationsPages/Video360DegreeDetail';
import VideoDetail from '../components/DestinationsPages/VideoDetail';
import DFPAd from '../components/DFPAd';
import ExternalProductCarousel from '../components/ExternalProductCarousel';
import Footer from '../components/Footer';
import CompetitionAndPolls from '../components/Forms/Competition-And-Polls';
import CompetitionForm from '../components/Forms/CompetitionForm';
import GenericForm from '../components/Forms/GenericForm';
import TravelForm from '../components/Forms/Travel-Form';
import Header from '../components/Header';
import HeroBannerAdCard from '../components/HeroCards/HeroBannerAdCard';
import HeroBannerArticle from '../components/HeroCards/HeroBannerArticle';
import HeroBannerCollection from '../components/HeroCards/HeroBannerCollection';
import HeroBannerCompetition from '../components/HeroCards/HeroBannerCompetition';
import HeroBannerEvent from '../components/HeroCards/HeroBannerEvent';
import HeroBannerImage from '../components/HeroCards/HeroBannerImage';
import HeroBannerImageGallery from '../components/HeroCards/HeroBannerImageGallery';
import HeroBannerLiveStream from '../components/HeroCards/HeroBannerLiveStream';
import HeroBannerLiveStreamViaEPG from '../components/HeroCards/HeroBannerLiveStreamViaEPG';
import HeroBannerPodcast from '../components/HeroCards/HeroBannerPodcast';
import HeroBannerPoll from '../components/HeroCards/HeroBannerPoll';
import HeroBannerQuiz from '../components/HeroCards/HeroBannerQuiz';
import HeroBannerQuote from '../components/HeroCards/HeroBannerQuote';
import HeroBannerVideo from '../components/HeroCards/HeroBannerVideo';
import HeroBannerVideo360 from '../components/HeroCards/HeroBannerVideo360';
import HeroSliderAuto from '../components/HeroSliderAuto';
import DFPHPTOBillboard from '../components/Home/DFPHPTOBillboard';
import FullWidthContainer from '../components/Home/FullWidthContainer';
import HomeContainer from '../components/Home/HomeContainer';
import MatchCarousel from '../components/Home/MatchCarousel';
import NewsGrid10 from '../components/Home/NewsGrid10';
import NewsGrid2 from '../components/Home/NewsGrid2';
import NewsGrid6 from '../components/Home/NewsGrid6';
import NewsGridCuration from '../components/Home/NewsGridCuration';
import ShopCarousel from '../components/Home/ShopCarousel';
import Spotlight from '../components/Home/Spotlight';
import SpotlightandEpg from '../components/Home/SpotlightandEpg';
import ThemedCarousel from '../components/Home/ThemedCarousel';
import LeagueTable from '../components/LeagueTable';
import Listing from '../components/Listing';
import ManagerDetail from '../components/ManagerDetail';
import MatchCenter from '../components/MatchCenter';
import Matches from '../components/Matches';
import MemberManagement from '../components/Musc/MemberManagement';
import MuscTicketApplication from '../components/Musc/MuscTicketApplication';
import ViewPreviousSubmission from '../components/Musc/ViewPreviousSubmission';
import Carousel from '../components/Mutv/Carousel';
import Container from '../components/Mutv/Container';
import EPG from '../components/Mutv/EPG';
import HeroContainer from '../components/Mutv/HeroContainer';
import MUTVHomeContainer from '../components/Mutv/MUTVHomeContainer';
import MyList from '../components/Mutv/MyList';
import PodcastEpisode from '../components/Mutv/PodcastEpisode';
import Show from '../components/Mutv/Show';
import VideoEpisode from '../components/Mutv/VideoEpisode';
import MyUnited from '../components/MyUnited';
import MyUnitedSettings from '../components/MyUnitedSettings';
import NewSearch from '../components/NewSearch';
import NonMatchDay from '../components/NonMatchDay';
import OneRow from '../components/OneRow';
import PlayerGrid from '../components/PlayerGrid';
import PlayerProfileDetail from '../components/PlayerProfileDetail';
import PlayerStats from '../components/PlayerStats';
import Search from '../components/Search';
import SignIn from '../components/SignIn';
import SocialDetail from '../components/SocialDetail';
import Stats from '../components/Stats';
import StructuredData from '../components/StructuredData';
import SVG from '../components/SVG';
import Accordion from '../components/Templates/Accordion';
import Basic from '../components/Templates/Basic';
import BasicBlock from '../components/Templates/BasicBlock';
import CManager from '../components/Templates/CManager';
import ContactUs from '../components/Templates/ContactUs';
import Divider from '../components/Templates/Divider';
import Download from '../components/Templates/Download';
import HeroAccordion from '../components/Templates/HeroAccordion';
import HeroImage from '../components/Templates/HeroImage';
import PricePackBanner from '../components/Templates/PricePackBanner';
import PromoBox from '../components/Templates/PromoBox';
import SignPost from '../components/Templates/SignPost';
import SignpostBlock from '../components/Templates/SignpostBlock';
import SignPostBlockContainer from '../components/Templates/SignPostBlockContainer';
import SignPostGrid from '../components/Templates/SignPostGrid';
import SignPostGridContainer from '../components/Templates/SignPostGridContainer';
import SignPostHeroContainer from '../components/Templates/SignPostHeroContainer';
import SubNavigation from '../components/Templates/SubNavigation';
import Table from '../components/Templates/Table';
import TicketsAndEvents from '../components/Templates/TicketsAndEvents';
import WayinForm from '../components/Templates/WayinForm';
import UnitedRewards from '../components/UnitedRewards';

const components = new Map();
components.set('AMPFooter', AMPFooter);
components.set('AMPHeader', AMPHeader);
components.set('AdCard', AdCard);
components.set('Article', Article);
components.set('Collection', Collection);
components.set('Competition', Competition);
components.set('FanaticsProduct', FanaticsProduct);
components.set('Googleprovider', Googleprovider);
components.set('Image', Image);
components.set('ImageGallery', ImageGallery);
components.set('LiveBlogEvent', LiveBlogEvent);
components.set('LiveStream', LiveStream);
components.set('MatchCard', MatchCard);
components.set('PlayerProfile', PlayerProfile);
components.set('Podcast', Podcast);
components.set('Poll', Poll);
components.set('Quiz', Quiz);
components.set('Quotes', Quotes);
components.set('Social', Social);
components.set('Teamlevelcalendar', Teamlevelcalendar);
components.set('Unitedcompetition', Unitedcompetition);
components.set('Video', Video);
components.set('Video360Degree', Video360Degree);
components.set('Coach', Coach);
components.set('ComingSoon', ComingSoon);
components.set('Comingup', Comingup);
components.set('EventCountDownTimer', EventCountDownTimer);
components.set('ContentBlock', ContentBlock);
components.set('AMPArticleDetail', AMPArticleDetail);
components.set('ArticleDetail', ArticleDetail);
components.set('CollectionDetail', CollectionDetail);
components.set('CompetitionDetail', CompetitionDetail);
components.set('CompetitionDetailForm', CompetitionDetailForm);
components.set('ImageDetail', ImageDetail);
components.set('ImageGalleryDetail', ImageGalleryDetail);
components.set('LiveStreamDetail', LiveStreamDetail);
components.set('LiveStreamViaEPGDetail', LiveStreamViaEPGDetail);
components.set('ModelContainer', ModelContainer);
components.set('PollDetail', PollDetail);
components.set('QuizDetail', QuizDetail);
components.set('QuotesDetail', QuotesDetail);
components.set('Video360DegreeDetail', Video360DegreeDetail);
components.set('VideoDetail', VideoDetail);
components.set('DFPAd', DFPAd);
components.set('ExternalProductCarousel', ExternalProductCarousel);
components.set('Footer', Footer);
components.set('Competition-And-Polls', CompetitionAndPolls);
components.set('CompetitionForm', CompetitionForm);
components.set('GenericForm', GenericForm);
components.set('Travel-Form', TravelForm);
components.set('Header', Header);
components.set('HeroBannerAdCard', HeroBannerAdCard);
components.set('HeroBannerArticle', HeroBannerArticle);
components.set('HeroBannerCollection', HeroBannerCollection);
components.set('HeroBannerCompetition', HeroBannerCompetition);
components.set('HeroBannerEvent', HeroBannerEvent);
components.set('HeroBannerImage', HeroBannerImage);
components.set('HeroBannerImageGallery', HeroBannerImageGallery);
components.set('HeroBannerLiveStream', HeroBannerLiveStream);
components.set('HeroBannerLiveStreamViaEPG', HeroBannerLiveStreamViaEPG);
components.set('HeroBannerPodcast', HeroBannerPodcast);
components.set('HeroBannerPoll', HeroBannerPoll);
components.set('HeroBannerQuiz', HeroBannerQuiz);
components.set('HeroBannerQuote', HeroBannerQuote);
components.set('HeroBannerVideo', HeroBannerVideo);
components.set('HeroBannerVideo360', HeroBannerVideo360);
components.set('HeroSliderAuto', HeroSliderAuto);
components.set('DFPHPTOBillboard', DFPHPTOBillboard);
components.set('FullWidthContainer', FullWidthContainer);
components.set('HomeContainer', HomeContainer);
components.set('MatchCarousel', MatchCarousel);
components.set('NewsGrid10', NewsGrid10);
components.set('NewsGrid2', NewsGrid2);
components.set('NewsGrid6', NewsGrid6);
components.set('NewsGridCuration', NewsGridCuration);
components.set('ShopCarousel', ShopCarousel);
components.set('Spotlight', Spotlight);
components.set('SpotlightandEpg', SpotlightandEpg);
components.set('ThemedCarousel', ThemedCarousel);
components.set('LeagueTable', LeagueTable);
components.set('Listing', Listing);
components.set('ManagerDetail', ManagerDetail);
components.set('MatchCenter', MatchCenter);
components.set('Matches', Matches);
components.set('MemberManagement', MemberManagement);
components.set('MuscTicketApplication', MuscTicketApplication);
components.set('ViewPreviousSubmission', ViewPreviousSubmission);
components.set('Carousel', Carousel);
components.set('Container', Container);
components.set('EPG', EPG);
components.set('HeroContainer', HeroContainer);
components.set('MUTVHomeContainer', MUTVHomeContainer);
components.set('MyList', MyList);
components.set('PodcastEpisode', PodcastEpisode);
components.set('Show', Show);
components.set('VideoEpisode', VideoEpisode);
components.set('MyUnited', MyUnited);
components.set('MyUnitedSettings', MyUnitedSettings);
components.set('NewSearch', NewSearch);
components.set('NonMatchDay', NonMatchDay);
components.set('OneRow', OneRow);
components.set('PlayerGrid', PlayerGrid);
components.set('PlayerProfileDetail', PlayerProfileDetail);
components.set('PlayerStats', PlayerStats);
components.set('Search', Search);
components.set('SignIn', SignIn);
components.set('SocialDetail', SocialDetail);
components.set('Stats', Stats);
components.set('StructuredData', StructuredData);
components.set('SVG', SVG);
components.set('Accordion', Accordion);
components.set('Basic', Basic);
components.set('BasicBlock', BasicBlock);
components.set('CManager', CManager);
components.set('ContactUs', ContactUs);
components.set('Divider', Divider);
components.set('Download', Download);
components.set('HeroAccordion', HeroAccordion);
components.set('HeroImage', HeroImage);
components.set('PricePackBanner', PricePackBanner);
components.set('PromoBox', PromoBox);
components.set('SignPost', SignPost);
components.set('SignpostBlock', SignpostBlock);
components.set('SignPostBlockContainer', SignPostBlockContainer);
components.set('SignPostGrid', SignPostGrid);
components.set('SignPostGridContainer', SignPostGridContainer);
components.set('SignPostHeroContainer', SignPostHeroContainer);
components.set('SubNavigation', SubNavigation);
components.set('Table', Table);
components.set('TicketsAndEvents', TicketsAndEvents);
components.set('WayinForm', WayinForm);
components.set('UnitedRewards', UnitedRewards);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
